import './SuggestionPart.css';
export var suggestionPartSectionInfoCSS = '_19hnlpe0-2-0-1';